import React from "react";

function Faqicon({ color = "#414149", width = 24, height = 24 }) {
  return (
    <svg
    width={width+""}
      height={height+""}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_2298_7427"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2298_7427)">
        <path
          d="M13.75 14.7692C13.9948 14.7692 14.2086 14.6779 14.3913 14.4952C14.5739 14.3126 14.6652 14.0988 14.6652 13.8538C14.6652 13.6089 14.5739 13.3952 14.3913 13.2125C14.2086 13.0298 13.9948 12.9385 13.75 12.9385C13.5052 12.9385 13.2914 13.0298 13.1087 13.2125C12.9259 13.3952 12.8345 13.6089 12.8345 13.8538C12.8345 14.0988 12.9259 14.3126 13.1087 14.4952C13.2914 14.6779 13.5052 14.7692 13.75 14.7692ZM13.1538 11.7615H14.346C14.3588 11.3102 14.4169 10.9753 14.5203 10.7568C14.6234 10.5381 14.8679 10.2423 15.2538 9.86925C15.7153 9.42692 16.0293 9.05317 16.196 8.748C16.3627 8.443 16.446 8.08858 16.446 7.68475C16.446 6.97308 16.1947 6.38617 15.6923 5.924C15.1898 5.46183 14.5423 5.23075 13.75 5.23075C13.1308 5.23075 12.5863 5.40158 12.1163 5.74325C11.6464 6.08492 11.3051 6.54358 11.0922 7.11925L12.173 7.573C12.3423 7.16917 12.5593 6.86633 12.824 6.6645C13.0888 6.4625 13.3975 6.3615 13.75 6.3615C14.1885 6.3615 14.5487 6.48842 14.8307 6.74225C15.1127 6.99608 15.2538 7.33075 15.2538 7.74625C15.2538 7.99875 15.1823 8.23558 15.0395 8.45675C14.8965 8.67792 14.6487 8.95 14.2962 9.273C13.8102 9.69867 13.4983 10.057 13.3605 10.348C13.2227 10.6392 13.1538 11.1103 13.1538 11.7615ZM8.05775 17.5C7.55258 17.5 7.125 17.325 6.775 16.975C6.425 16.625 6.25 16.1974 6.25 15.6923V4.30775C6.25 3.80258 6.425 3.375 6.775 3.025C7.125 2.675 7.55258 2.5 8.05775 2.5H19.4423C19.9474 2.5 20.375 2.675 20.725 3.025C21.075 3.375 21.25 3.80258 21.25 4.30775V15.6923C21.25 16.1974 21.075 16.625 20.725 16.975C20.375 17.325 19.9474 17.5 19.4423 17.5H8.05775ZM8.05775 16H19.4423C19.5193 16 19.5898 15.9679 19.6538 15.9038C19.7179 15.8398 19.75 15.7692 19.75 15.6923V4.30775C19.75 4.23075 19.7179 4.16025 19.6538 4.09625C19.5898 4.03208 19.5193 4 19.4423 4H8.05775C7.98075 4 7.91025 4.03208 7.84625 4.09625C7.78208 4.16025 7.75 4.23075 7.75 4.30775V15.6923C7.75 15.7692 7.78208 15.8398 7.84625 15.9038C7.91025 15.9679 7.98075 16 8.05775 16ZM4.55775 21C4.05258 21 3.625 20.825 3.275 20.475C2.925 20.125 2.75 19.6974 2.75 19.1923V6.30775H4.25V19.1923C4.25 19.2693 4.28208 19.3398 4.34625 19.4038C4.41025 19.4679 4.48075 19.5 4.55775 19.5H17.4423V21H4.55775Z"
          fill={color}
        />
      </g>
    </svg>
  );
}

export default Faqicon;
